import { render, staticRenderFns } from "./SingleOrderCreated.vue?vue&type=template&id=cbfb4522&lang=pug&"
import script from "./SingleOrderCreated.vue?vue&type=script&lang=js&"
export * from "./SingleOrderCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports